import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linebreakAtUnderscores',
    standalone: false
})
export class LinebreakAtUnderscoresPipe implements PipeTransform {

  transform(keyAttribute: string): string {
   return keyAttribute.replace(/_/g, '_\u200B');
  }

}
